import * as React from 'react';
import axios from 'axios';

/**
 * When a component unmounts, we need to cancel any potentially
 * ongoing Axios calls that result in a state update on success / fail.
 * This function sets up the appropriate useEffect to handle the canceling.
 *
 * @returns {signal: AbortSignal, isCancel: function}
 * signal - abort controller signal sent in the Axios request.
 * isCancel - used to check if error returned in response is a cancel token error.
 */
const useAbortSignal = (
  mounted: boolean
): {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isCancel: (value: any) => boolean;
  signal: AbortSignal;
} => {
  const abortControllerRef = React.useRef<AbortController>(new AbortController());
  const isCancel = axios.isCancel;

  React.useEffect(
    () => () => {
      if (mounted) {
        abortControllerRef.current.abort();
      }
    },
    [mounted]
  );

  return { signal: abortControllerRef.current.signal, isCancel };
};

export default useAbortSignal;
